import EA from 'helpers/init';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default EA.Methods.textColorAnim = ($this) => {
    $this.querySelectorAll('.text-color').forEach((el) => {
        const splitLines = new SplitText(el, { type: 'lines' });
        const splitWords = new SplitText(splitLines.lines, { type: 'words' });

        gsap.timeline({
            scrollTrigger: {
                trigger: $this,
                start: '0 60%'
            }
        }).from(splitWords.words, {
            color: '#718094',
            duration: 0.2,
            stagger: 0.04,
            ease: 'power3.inOut',
            onComplete: () => {
                splitWords.revert();
                splitLines.revert();
            }
        });
    });
};
